// import './_language.js';

window.addEventListener("load", function () {
  // Burger menu toggle
  $(".burger__item").on("click", function () {
    $(this).toggleClass("close");
    $(".group__menu").toggleClass("active");
  });

  // $(".group__menu--item").on("click", function(e) {
  //     const index = $(this).index();
  //     // Only open popup for items 2, 3, 4 (index 1, 2, 3)
  //     if (index >= 2 && index <= 3) {
  //         e.preventDefault();
  //         $(".popup_coming").addClass("active");
  //     }
  // });
});
